import { Box } from "@mui/material";
import React, { FunctionComponent, memo, useState } from "react";

import { Anomaly as AnomalyType, getUtilityBillById } from "api";

import { EsgAnomalyWarning } from "assets";

import { setToLocalStorage } from "utils";
import { UTILITY_BILL_PAGE } from "../../consts";

type AnomalyProps = Omit<AnomalyType, "createDate">;

export const Anomaly: FunctionComponent<AnomalyProps> = memo(
  ({
    anomalyType,
    message,
    bgColor = "#E215151A",
    previousBillGuid,
  }) => {
    const [isHovered, setIsHovered] = useState(false);

    const onPreviousBillViewClick = () => {
      if (previousBillGuid) {
        window.open(`${UTILITY_BILL_PAGE.ABSOLUTE_PATH(previousBillGuid)}`);
      }
    };

    const handlePreviousBillCardClick = async (id: any) => {
      if (id) {
        window.open(`${UTILITY_BILL_PAGE.ABSOLUTE_PATH(id as string)}`);
        try {
          const response = await getUtilityBillById(id);
          setToLocalStorage(
            "document",
            JSON.stringify({
              documentGuid: response.documentGuid,
              filename: response.filename,
            }),
          );
        } catch (error) {
          console.error("Error fetching utility bill:", error);
          throw error;
        }
      }
    };

    const isUsageAnomaly = anomalyType === "Usage" && message && /-?\d+(\.\d+)?%/.test(message);
    const anomalyMessage = isUsageAnomaly ? (
      // eslint-disable-next-line
      <a
        href="#"
        style={{
          textDecoration: "none",
          cursor: "pointer",
          color: isHovered ? "black" : "#000302",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onPreviousBillViewClick}
        title={
          previousBillGuid && previousBillGuid?.length >= 1
            ? `${UTILITY_BILL_PAGE.ABSOLUTE_PATH(previousBillGuid as string)}`
            : ""
        }
      >
        {message}
      </a>
    ) : (
      message
    );

    return (
      <Box sx={{ bgcolor: bgColor, borderRadius: "4px", padding: "24px 16px", cursor: 'pointer', width: "584px" }}
        onClick={() => handlePreviousBillCardClick(previousBillGuid)}
      >
        <Box sx={{
          display: "flex",
          gap: "10px",
          marginBottom: 0,
          marginLeft: "10px",
          "& > h3": {
            margin: 0,
            fontWeight: "600",
            fontSize: "14px",
          },
        }}>
          <EsgAnomalyWarning />
          <h3>Verification Failed | {anomalyType}</h3>
        </Box>

        <ul style={{ fontSize: "12px", fontWeight: "500", paddingInlineStart: "25px", marginBottom: 0 }}>
          <li>{anomalyMessage}</li>
          <li style={{ lineHeight: "16px" }}>
            Please <span style={{ color: "#E21515" }}>review the data</span> and make any necessary corrections, or click &quot;Confirm Data&quot; if everything is accurate.</li>
        </ul>
      </Box>
    );
  },
);
